import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchSupportUnreadSummary } from "../redux/slice/supportNotifications.slice";

/**
 * Polls the admin support unread-summary endpoint every 30 seconds while
 * the component is mounted, the admin has Support access, and the tab is
 * visible. Called from DashboardLayout.container.js.
 *
 * @param {boolean} enabled   Gate; usually accessRights.includes(SUPPORT_TICKET_ACCESS).
 * @param {number}  pollMs    Interval in ms (default 30_000).
 */
export default function useSupportUnreadPoll(enabled, pollMs = 30000) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!enabled) return undefined;

    let intervalId = null;
    const tick = () => {
      dispatch(fetchSupportUnreadSummary());
    };

    const start = () => {
      if (intervalId) return;
      intervalId = setInterval(tick, pollMs);
    };
    const stop = () => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };

    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        tick();
        start();
      } else {
        stop();
      }
    };

    tick();
    if (document.visibilityState === "visible") start();
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      stop();
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [enabled, pollMs, dispatch]);
}
